import { withTheme } from '@digital-retail/falabella-ui-cross-components';
import { isSodimacStandalone, isTottusStandalone, isWhitelabel } from '@digital-retail/store-manager';
import { cx } from 'cvb';
import PropTypes from 'prop-types';
import React from 'react';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import { noop } from '../../../utils/noop';
import { buttonStyle } from './button.style';

const Button = ({
  children,
  onClick,
  type,
  isHighlighted,
  disabled,
  id,
  size,
  strech,
  letterSpace,
  theme,
  extraClasses,
  appCtx,
}) => {
  const { store } = appCtx;
  const themedButtonStyle = buttonStyle(theme, store);
  const idAttr = id ? { id } : {};
  return (
    <button
      disabled={disabled}
      className={cx(
        'button',
        type && `button-${type}`,
        isHighlighted && 'button-bold',
        size && `button-${type}-${size}`,
        strech && `button-${type}-strech-${strech}`,
        letterSpace && `button-${type}-letter-${letterSpace}`,
        extraClasses,
        isSodimacStandalone(appCtx.store) && 'so_com',
        isTottusStandalone(appCtx.store) && 'to_com',
        isWhitelabel({ store: appCtx.store }) && 'whitelabel'
      )}
      type="button"
      onClick={onClick}
      {...idAttr}
    >
      {children}
      <style jsx>{themedButtonStyle}</style>
    </button>
  );
};

Button.defaultProps = {
  children: null,
  type: 'primary',
  onClick: noop,
  isHighlighted: false,
  disabled: false,
  id: '',
  size: '',
  strech: '',
  letterSpace: '',
  theme: null,
  extraClasses: '',
};

Button.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf([
    'primary',
    'secondary',
    'tertiary',
    'quatinery',
    'link',
    'secondary-link',
    'tertiary-link',
    '',
    'outline',
    'sort-button',
    'button-secondary-no-width',
    'mkp-primary',
    'mkp-primary-outlined',
    'mkp-primary-medium',
    'mkp-primary-xtra-large',
    'mkp-secondary',
    'mkp-quatinery generic-outlined',
    'mkp-secondary generic-outlined',
    'generic-outlined',
  ]),
  isHighlighted: PropTypes.bool,
  id: PropTypes.string,
  size: PropTypes.oneOf(['medium', 'large', 'xtra-large', 'small', '']),
  strech: PropTypes.oneOf(['full', 'auto', '']),
  letterSpace: PropTypes.oneOf(['small', 'regular', '']),
  theme: PropTypes.object,
  extraClasses: PropTypes.string,
  appCtx: PropTypes.object.isRequired,
};

export default withApplicationContext(withTheme(Button));
